import type { TextProps } from '@chakra-ui/react';
import { Skeleton, Text } from '@chakra-ui/react';
import type { ReactNode } from 'react';
import React from 'react';

interface SkeletonOrTextProps extends TextProps {
  children?: ReactNode;
}

const SkeletonOrText: React.FC<SkeletonOrTextProps> = ({
  children,
  ...textProps
}) => {
  return (
    <Skeleton asChild display="inline" loading={!children}>
      <Text as="span" {...textProps}>
        {children ?? '--'}
      </Text>
    </Skeleton>
  );
};

export default SkeletonOrText;
